import { Routes } from "@angular/router";
import { requireLoggedIn } from "@tylertech/core-module";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
export const appRoutes: Routes = [
    // TODO(DO-4549) - What is this route for? why is it different from the default.
    {
        path: "module/:module*",
        component: DashboardComponent,
        title: "My Dashboard [module]",
        canActivate: [requireLoggedIn]
    },
    // FIXME(DO-4549) - Something still relies on this router param, but nothing is paying attention to it in this app....
    {
        path: ":embedded",
        redirectTo: ""
    },
    {
        path: "",
        component: DashboardComponent,
        title: "My Dashboard",
        canActivate: [requireLoggedIn]
    },
];
